export default __webpack_public_path__ + "static/qr-white-07eebb3e7e60c59a4c1500998a6c8967.png";